import { graphql, useStaticQuery } from 'gatsby';

export type ICountriesData = {
  posts: {
    edges: {
      node: {
        data_source: string;
        name: string;
      };
    }[];
  };
};

const useCountriesData = () => {
  const data: ICountriesData = useStaticQuery(graphql`
    {
      posts: allStoryblokDatasourceEntry(
        filter: { data_source: { eq: "countries" } }
      ) {
        edges {
          node {
            data_source
            name
          }
        }
      }
    }
  `);

  return data.posts.edges.map((edge) => edge.node.name);
};

export default useCountriesData;
